
<button 
	class="video" 
	(click)="playVideo(article)" 
	*ngIf="article.field_video_id && article.field_video_platform"
>

	<div class="media-container">
		<app-media 
			class="thumbnail" 
			kind="default" 
			alt="{{article.title}}" 
			[src]="getSrc(article)" 
			loading="lazy"
		></app-media>
		
	</div>
	<div class="text-container">
		<h2>{{article.title}}</h2>
		<h3>{{article.field_sub_title}}</h3>
		<span class="play-button">
			<app-icon class="play-button-icon" name="playCircle"></app-icon>
			<span class="play-button-label" [innerHtml]="getPlayBtnLabel(isPlayingOnPage$ | push)" ></span>
		</span>
	</div>
</button>
